import {TuiDay} from '@taiga-ui/cdk';
import {UmpireImage} from '../umpire-image';

export interface UmpireMatchPredictorRanking {
  id: string | null;
  date_from: TuiDay | string | null;
  date_to: TuiDay | string | null;
  name: string;
  image: UmpireImage | null;
  type: 'match_predictor_ranking';
  resource: UmpireMatchPredictorResource | null;
  is_draft: boolean;
  publication_time: string | null;
  published_at: string | null;
  relationshipNames: string[];
}

export interface UmpireMatchPredictorRankingUserResult {
  id: string;
}

export interface UmpireMatchPredictorRankingForm extends UmpireMatchPredictorRanking {
  resource_type: UmpireMatchPredictorRankingTypeEnum | null;
}

export interface UmpireMatchPredictorResource {
  id: string;
  type: 'competition_season' | 'stage' | 'group' | 'round';
}

export enum UmpireMatchPredictorRankingTypeEnum {
  CompetitionSeason = 'competition_season',
  Stage = 'stage',
  Group = 'group',
  Round = 'round',
}
